import React from 'react';
import styled from 'styled-components';
import { Paper, Grid } from '@material-ui/core';

import { initial } from './index';

type CardPaperProps = {
  width: number;
  height: number;
}
const CardPaper = styled(Paper)<CardPaperProps>`
  position: relative;
  width: ${props => props.width + 'px'};
  height: ${props => props.height + 'px'};
  display: grid;
  align-items: center;
`

type MemoCardPreviewProps = {
  selected?: boolean;
}
const MemoCardPreview: React.FC<MemoCardPreviewProps> = ({ selected }) => {
  const borderStyle = '1px solid #000000';
  const selectedStyle = '2px solid #1e88e5';

  return (
    <CardPaper style={{ border: selected ? selectedStyle : borderStyle }} width={initial.cardWidth} height={initial.cardHeight}>
      <Grid container justify="center">
        <div>メモカード</div>
      </Grid>
    </CardPaper>
  );
}

export default MemoCardPreview;
